import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COLOR_TEXT_SECONDARY } from '../colors/colors';

const DEFAULT_TEXT_COLOR = COLOR_TEXT_SECONDARY;

const FooterPrivacyNotice = styled.p`
  font-size: 12px;
  color: ${({ $color }) => $color || DEFAULT_TEXT_COLOR};
  text-align: center;
  margin: 16px 0px 0px 0px;
  max-width: 420px;

  button {
    border: 0;
    color: ${({ $color }) => $color || DEFAULT_TEXT_COLOR};
    padding: 0;
    cursor: pointer;
    background: none;
    font-size: 12px;
    text-decoration: underline;
  }
`;

const YouFooter = ({
  getTranslationAsString,
  trackButtonClick,
  privacyPolicyUrl,
  termOpenFinance = false,
  beforeLinkText,
  linkText,
  afterLinkText,
  color,
}) => {
  const openTermPrivacyPolicy = () => {
    if (trackButtonClick) {
      trackButtonClick('open_privacy_policy', 'footer');
    }
    window.open(privacyPolicyUrl, '_blank', 'noopener');
  };

  const renderContent = () => {
    if (beforeLinkText && linkText) {
      return <>{beforeLinkText}<button onClick={openTermPrivacyPolicy}>{linkText}</button>{afterLinkText || ''}</>;
    }

    if (termOpenFinance) {
      return <>{getTranslationAsString('footer.unicoUses')} <br />{getTranslationAsString('footer.checkTerms')} <button onClick={openTermPrivacyPolicy}>{getTranslationAsString('footer.termsOfUse')}</button>.</>;
    }

    return <>{getTranslationAsString('footer.agreeWith')} <button onClick={openTermPrivacyPolicy}>{getTranslationAsString('footer.privacyNotice')}</button> {getTranslationAsString('footer.shareData')}</>;
  };

  return (
    <FooterPrivacyNotice
      data-testid="footer-privacy-notice"
      $color={color}
    >
      {renderContent()}
    </FooterPrivacyNotice>
  );
};

YouFooter.propTypes = {
  getTranslationAsString: PropTypes.func,
  trackButtonClick: PropTypes.func,
  privacyPolicyUrl: PropTypes.string.isRequired,
  termOpenFinance: PropTypes.bool,
  beforeLinkText: PropTypes.string,
  linkText: PropTypes.string,
  afterLinkText: PropTypes.string,
  color: PropTypes.string,
};

export { YouFooter };
